import ReactECharts from 'echarts-for-react';

const GenericChart = ({
  type = 'line', // Default chart type
  title = '', // Chart title
  data = [], // Series data
  categories = [], // X-axis categories (for bar/line)
  options = {}, // Additional ECharts options
  height = '100%', // Height of chart
  width = '100%', // Width of chart
}) => {
  const baseOption = {
    title: { text: title },
    tooltip: { trigger: 'item' },
    legend: {},
    xAxis: ['line', 'bar'].includes(type)
      ? { type: 'category', data: categories }
      : undefined,
    yAxis: ['line', 'bar'].includes(type) ? { type: 'value' } : undefined,
    series: [
      {
        type,
        data,
        ...(['line'].includes(type) ? { smooth: true } : {}),
      },
    ],
    ...options, // Allow full override
  };

  return <ReactECharts option={baseOption} style={{ height, width }} />;
};

export default GenericChart;
